import React from "react";

const variantClasses = {
  h1: "font-semibold text-[8px]",
  h2: "font-extrabold sm:text-[28px] md:text-[30px] text-[32px]",
  h3: "sm:text-[24px] md:text-[26px] text-[28px]",
  h4: "font-black sm:text-[22px] md:text-[24px] text-[26px]",
  h5: "font-bold sm:text-[20px] md:text-[22px] text-[24px]",
  h6: "font-extrabold text-[20px]",
  body1: "text-[18px]",
  body2: "text-[16px]",
  body3: "text-[14px]",
  body4: "text-[12px]",
  body5: "text-[10px]",
};

const Text = ({ children, className, variant, as, ...restProps }) => {
  const Component = as || "span";
  return (
    <Component
      className={`${className} ${variant && variantClasses[variant]}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Text };
